import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    btnSend: {
        height: "48px",
        width: "100%",
    },
}));
